<template>
  <div class="bg">
    <div class="bg-b">
        <div class="script">404</div>
        <!-- <div class="script-1">无法访问</div> -->
    </div>
  </div>
</template>

<style scoped lang="less">
.script{
    color: #ff7474;
    font: 15em sans-serif;
}
.script-1{
    color: #ff7474;
    font: 7em sans-serif;
}
.bg {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url('~@/assets/images/login.jpg') no-repeat;
  background-size: cover;
}
.bg-b{
    text-align: center;
    width: 100%;
    background: #ffffffb2;
}
</style>
